export default function def_day_lines(dates,ann){
  var day;
  var hhm,hh,delta,pos
  for(let i=0; i < dates.length; i++){
    if(i == 0){
      hhm=parseInt(dates[i].substring(4,6));
      continue;
    }
    hh=parseInt(dates[i].substring(4,6));
    // Note: if delta h is 24h, hh will be equal to hhm
    // and we must also put a vertical line for that case.
    if(hh <= hhm ){
      delta = hh + 24 - hhm;
      pos=i-hh/delta;
      day = {
	type: 'line',
	borderColor: 'black',
	borderWidth: 1,
	scaleID: 'x',
	value: pos
      };
      ann.push(day);
    }
    hhm=hh;
  }
}
